export default {
  LOAD_LIST_CONTAS(state, payload) {
    state.listContas = payload
  },
  PREPARE_TO_EDIT_CONTA(state, payload) {
    state.conta = payload
  },
  RESET_CONTA(state) {
    state.conta = {
      id: '',
      nome: '',
      descricao: '',
      tipoConta: null,
      banco: null,
      agencia: '',
      conta: '',
      digitoVerificador: '',
      dataSaldoInicial: null,
      valorSaldoInicial: 0.0,
      moeda: 'BRL',
      principal: false,
      permiteSaldoNegativo: false,
      ativo: true
    }
  }
}
